import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../core/services/seo.service';
import { LegalLayoutComponent } from './legal-layout.component';

@Component({
  selector: 'app-agb-kunden',
  standalone: true,
  imports: [LegalLayoutComponent, RouterLink],
  templateUrl: './agb-kunden.component.html',
})
export class AgbKundenComponent {
  constructor() {
    inject(SeoService).apply({
      title: 'AGB für Endkunden · Craftly',
      description: 'Allgemeine Geschäftsbedingungen für Endkunden auf der Craftly-Plattform.',
      path: '/agb',
      type: 'article',
    });
  }
}
